var map = {
	"./decidim/avatar-multiuser.png": 9457,
	"./decidim/brands/google.svg": 9276,
	"./decidim/cc-badge.png": 7639,
	"./decidim/decidim-logo.svg": 4771,
	"./decidim/default-avatar.svg": 5143,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 4973,
	"./decidim/icons.svg": 1494,
	"./decidim/pattern.png": 741,
	"./decidim/placeholder-card-g.svg": 1434,
	"./decidim/placeholder-card-l.svg": 8289,
	"./decidim/placeholder.jpg": 8384,
	"./decidim/remixicon.symbol.svg": 4066,
	"./decidim/vendor/leaflet/layers-2x.png": 5439,
	"./decidim/vendor/leaflet/layers.png": 5926,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 4555,
	"./decidim/vendor/leaflet/marker-icon.png": 2498,
	"./decidim/vendor/leaflet/marker-shadow.png": 385,
	"./decidim/vendor/social-share-button/douban.svg": 914,
	"./decidim/vendor/social-share-button/email.svg": 4134,
	"./decidim/vendor/social-share-button/facebook.svg": 9742,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3122,
	"./decidim/vendor/social-share-button/hacker_news.svg": 966,
	"./decidim/vendor/social-share-button/linkedin.svg": 2188,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 8629,
	"./decidim/vendor/social-share-button/pinterest.svg": 7408,
	"./decidim/vendor/social-share-button/reddit.svg": 9546,
	"./decidim/vendor/social-share-button/telegram.svg": 7579,
	"./decidim/vendor/social-share-button/tumblr.svg": 4328,
	"./decidim/vendor/social-share-button/twitter.svg": 2475,
	"./decidim/vendor/social-share-button/vkontakte.svg": 7697,
	"./decidim/vendor/social-share-button/wechat.svg": 4772,
	"./decidim/vendor/social-share-button/whatsapp.svg": 4172,
	"./decidim/vendor/social-share-button/x.svg": 3726,
	"./decidim/vendor/social-share-button/xing.svg": 7898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3018;